import styled from 'styled-components'
import { Check, Times } from '@styled-icons/fa-solid'
import { Button } from '..'
import { ReactComponent as Sandbox } from '../../../assets/hobby-color.svg'
import { ReactComponent as Dev } from '../../../assets/dev-color.svg'
import { ReactComponent as Prod } from '../../../assets/prod-color.svg'
import variables from '../../styles/variables'

export const Table = styled.div`
  width: 100%;
  background: white;
`

export const TableCell = styled.div`
  padding: 10px;
  font-size: 0.7rem;
  @media ${variables.media.sm} {
    padding: 20px;
    font-size: 1rem;
  }
  
  .__react_component_tooltip {
    max-width: 200px;
  }
`
export const HeaderCellWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ColHeader = styled.span`
  font-size: 0.9rem;
  font-weight: bold;  
  display: flex;
  align-items: center;
  color: ${variables.colors.oracle.darker};
  @media ${variables.media.sm} {
    font-size: 1rem;
  }
  @media ${variables.media.md} {
    font-size: 1.2rem;
  }
`

export const ColSmallHeader = styled.span`
  display: block;
  font-weight: 300;
  margin-top: 10px;
  color: ${variables.colors.oracle.darker};
  font-size: 0.65rem;
  @media ${variables.media.sm} {
    font-size: 0.7rem;
  }
  @media ${variables.media.md} {
    font-size: 0.95rem;
  }
  
`
export const RowHeader = styled(ColHeader)`
  font-size: 0.9rem;
  @media ${variables.media.sm} {
    font-size: 1rem;
  }
`

export const RowSmallHeader = styled(RowHeader)`
  font-weight: normal;
  font-size: 0.7rem;
   @media ${variables.media.sm} {
    font-size: 0.95rem;
  }
`

export const CellText = styled.span`
  display: block;
  cursor: default;
  color: ${props => (props.color ? props.color : variables.colors.oracle.darker)};
  font-size: ${props => (props.textSize ? props.textSize : '1rem')};
  text-align: center;
  ${props => props.bold && 'font-weight: bold'};
`

export const CellSmallText = styled(CellText)`
  font-size: 0.8rem;
`

export const AspectRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f2f2f2;
  background: #fafafa;
  
  a {
    text-decoration: none;
  }

  ${TableCell}:nth-child(1) {
    width: 19%;
  }
  ${TableCell}:nth-child(2) {
    width: 27%;
  }
  ${TableCell}:nth-child(3) {
    width: 27%;
  }
  ${TableCell}:nth-child(4) {
    width: 27%;
  }
  @media ${variables.media.sm} {
    ${TableCell}:nth-child(1) {
      width: 25%;
    }
    ${TableCell}:nth-child(2) {
      width: 25%;
    }
    ${TableCell}:nth-child(3) {
      width: 25%;
    }
    ${TableCell}:nth-child(4) {
      width: 25%;
    }
  }
`
export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  ${AspectRow}:nth-child(1) {
    color: ${variables.colors.oracle.darker};
    background: #F1F1F1;
  }
  ${AspectRow}:last-child {
    border-bottom: none;
  }
`

export const SandboxIcon = styled(Sandbox)`
  display: none;
  margin-right: 10px;
  @media ${variables.media.sm} {
    display: block;
    width: 40px;
    height: 40px;
  }
  @media ${variables.media.md} {
    width: 55px;
    height: 55px;
  }
`

export const DevIcon = styled(Dev)`
  display: none;
  margin-right: 10px;
  @media ${variables.media.sm} {
    display: block;
    width: 40px;
    height: 40px;
  }
  @media ${variables.media.md} {
    width: 55px;
    height: 55px;
  }
`

export const ProdIcon = styled(Prod)`
  display: none;
  margin-right: 10px;
  @media ${variables.media.sm} {
    display: block;
    width: 40px;
    height: 40px;
  }
  @media ${variables.media.md} {
    width: 55px;
    height: 55px;
  }
`

export const CheckIcon = styled(Check)`
  width: 20px;
  height: 20px;
  display: block;
  margin: 0 auto;
  color: ${variables.colors.jade.medium};
`

export const NoIcon = styled(Times)`
  width: 20px;
  height: 20px;
  display: block;
  margin: 0 auto;
  color: #D8D8D8;
`

export const StyledButton = styled(Button)`
  white-space: normal;
  max-width: 100%;
  display: block;
  margin: 0 auto;
  padding: 5px;
  font-size: 0.65rem;
  @media ${variables.media.sm} {
    padding: 0.5rem 2rem;
    font-size: 0.8rem;
  }
`
